import { ICourseComponentInfo } from '@/courses/interfaces/params-component-selected';
import { SchoolDays } from '@/tools/models/school-days.model';
import {IParamsCreateComponent} from '@/courses/interfaces/params-create-component.interface';

export default class Course {
  id: any;
  type: string;
  classId: number;
  className: string;
  title: any;
  subtitle: any;
  img: any;
  sections: any[] = [];
  materials: any = [];
  materialsList: any = [];
  projects: any = [];
  users: any[] = [];
  meetingId: any;
  viewer = { 
    materialSelected: null,
    sectionSelected: null,
    projectSelected: null 
  };
  component: ICourseComponentInfo = { 
    name: null,
    section: null,
    edition: false,
    minDate: '',
    isLesson: false
  };
  mode: string;
  sectionCompletedTask: any;
  defaultDueDateForTasks: any;
  defaultLastDateForTasks: any;
  organizationId: any;
  contentSummary: any;
  categoryId: any;
  imgHash: any;
  hasGrading: boolean = false;
  schoolCalendar: SchoolDays;
  duration: number;
  showTeacherOnlyMessage: boolean;
  eduacComponents: IParamsCreateComponent[] = [];
  deckLibrary: any = {};
  origin = '';
  suggestedLessonDuration = 0;
  builderVersion = '';

  constructor(courseInfo = null, classId = 0, meetingId = null, className = '') {
    this.classId = classId;
    this.className = className;
    this.meetingId = meetingId;
    this.mode = '';
    this.sectionCompletedTask = null;
    if(courseInfo) {
      this.schoolCalendar = courseInfo.schoolCalendar;
      this.id = courseInfo.id;
      this.type = courseInfo.type;
      this.title = courseInfo.title;
      this.subtitle = courseInfo.subtitle;
      this.img = courseInfo.img;
      this.sections = courseInfo.sections ? courseInfo.sections : [];
      this.materials = courseInfo.materials ? courseInfo.materials : [];
      this.materialsList = courseInfo.materialsList ? courseInfo.materialsList : [];
      this.projects = courseInfo.projects ? courseInfo.projects : [];
      this.users = courseInfo.persons ? courseInfo.persons : []; 
      this.defaultDueDateForTasks = courseInfo.defaultDueDateForTasks;
      this.defaultLastDateForTasks = courseInfo.defaultLastDateForTasks;
      this.organizationId = courseInfo.organizationId;
      this.contentSummary = courseInfo.contentSummary;
      this.categoryId = courseInfo.categoryId;
      this.imgHash = courseInfo.imgHash;
      this.defaultLastDateForTasks = courseInfo.defaultLastDateForTasks;
      this.hasGrading = courseInfo.hasGrading;
      this.duration = courseInfo.duration;
      this.showTeacherOnlyMessage = courseInfo.showTeacherOnlyMessage;
      this.eduacComponents = courseInfo.eduacComponents;
      this.deckLibrary = courseInfo.deckLibrary ? courseInfo.deckLibrary : {};
      this.origin = courseInfo.origin || courseInfo.originTool || '';
      this.suggestedLessonDuration = courseInfo.suggestedLessonDuration || 0;
      this.builderVersion = courseInfo.builderVersion || ''
    }
  }
}